<script setup lang="ts">
import CardProgressContent from '@/components/ui/card/CardProgressContent.vue'
import type { RepartitionFormationViewModel } from '@/lib/types'
import RepartitionFormationRepository from '@/repository/RepartitionFormationRepository'
import { onMounted, ref } from 'vue'
import Card from '@/components/ui/card/Card.vue'

const data = ref<RepartitionFormationViewModel[] | null>(null)
const fields = ref<{ label: string; value: number }[]>([])

onMounted(async () => {
  data.value = await RepartitionFormationRepository.getInfoCardData()
  if (data.value) {
    fields.value = data.value.map((item) => ({
      label: item.label,
      value: item.value,
    }))
  }
})
</script>

<template>
  <Card title="Répartition des formations (année)">
    <CardProgressContent :fields="fields || []" :skeletons="4" />
  </Card>
</template>
